export const INVALIDATE_BRANDS_DATA = "INVALIDATE_BRANDS_DATA";
export const INVALIDATE_DATA_SPEED_GENS_DATA = "INVALIDATE_DATA_SPEED_GENS_DATA";
export const INVALIDATE_OFFER_EXTRA_GROUPS_DATA =
  "INVALIDATE_OFFER_EXTRA_GROUPS_DATA";
export const INVALIDATE_OFFER_EXTRAS_DATA = "INVALIDATE_OFFER_EXTRAS_DATA";
export const INVALIDATE_OFFER_TYPE_COUNTS = "INVALIDATE_OFFER_TYPE_COUNTS";
export const INVALIDATE_PHONE_CATEGORIES_DATA =
  "INVALIDATE_PHONE_CATEGORIES_DATA";
export const INVALIDATE_PHONE_OFFERS_DATA = "INVALIDATE_PHONE_OFFERS_DATA";
export const INVALIDATE_PHONE_OPERATING_SYSTEMS_DATA =
  "INVALIDATE_PHONE_OPERATING_SYSTEMS_DATA";
export const INVALIDATE_PHONE_STATES_DATA = "INVALIDATE_PHONE_STATES_DATA";
export const INVALIDATE_PHONE_VARIANTS_DATA = "INVALIDATE_PHONE_VARIANTS_DATA";
export const INVALIDATE_PHONES_DATA = "INVALIDATE_PHONES_DATA";
export const INVALIDATE_PORTAL_OFFER_DATA = "INVALIDATE_PORTAL_OFFER_DATA";
export const INVALIDATE_PORTAL_STATIC_DATA = "INVALIDATE_PORTAL_STATIC_DATA";
export const INVALIDATE_PROPOSITIONS_DATA = "INVALIDATE_PROPOSITIONS_DATA";
export const INVALIDATE_PROVIDERS_DATA = "INVALIDATE_PROVIDERS_DATA";
export const INVALIDATE_SHOPS_DATA = "INVALIDATE_SHOPS_DATA";
export const INVALIDATE_SIM_ONLY_OFFERS_DATA =
  "INVALIDATE_SIM_ONLY_OFFERS_DATA";
export const INVALIDATE_SPONSORED_POSITIONS_DATA =
  "INVALIDATE_SPONSORED_POSITIONS_DATA";
export const LOAD_BRAND_DATA = "LOAD_BRAND_DATA";
export const LOAD_BRAND_PHONE_OFFER_IDS_DATA =
  "LOAD_BRAND_PHONE_OFFER_IDS_DATA";
export const LOAD_BRAND_PROPOSITION_IDS_DATA =
  "LOAD_BRAND_PROPOSITION_IDS_DATA";
export const LOAD_BRANDS_DATA = "LOAD_BRANDS_DATA";
export const LOAD_DATA_SPEED_GEN_PROPOSITION_IDS_DATA = "LOAD_DATA_SPEED_GEN_PROPOSITION_IDS_DATA";
export const LOAD_DATA_SPEED_GEN_SIM_ONLY_IDS_DATA = "LOAD_DATA_SPEED_GEN_SIM_ONLY_IDS_DATA";
export const LOAD_DATA_SPEED_GENS_DATA = "LOAD_DATA_SPEED_GENS_DATA";
export const LOAD_OFFER_EXTRA_GROUP_DATA = "LOAD_OFFER_EXTRA_GROUP_DATA";
export const LOAD_OFFER_EXTRA_GROUPS_DATA = "LOAD_OFFER_EXTRA_GROUPS_DATA";
export const LOAD_OFFER_EXTRA_DATA = "LOAD_OFFER_EXTRA_DATA";
export const LOAD_OFFER_EXTRA_PHONE_OFFER_IDS_DATA =
  "LOAD_OFFER_EXTRA_PHONE_OFFER_IDS_DATA";
export const LOAD_OFFER_EXTRA_PROPOSITION_IDS_DATA =
  "LOAD_OFFER_EXTRA_PROPOSITION_IDS_DATA";
export const LOAD_OFFER_EXTRA_SIM_ONLY_IDS_DATA =
  "LOAD_OFFER_EXTRA_SIM_ONLY_IDS_DATA";
export const LOAD_OFFER_EXTRAS_DATA = "LOAD_OFFER_EXTRAS_DATA";
export const LOAD_PHONE_CATEGORY_DATA = "LOAD_PHONE_CATEGORY_DATA";
export const LOAD_PHONE_CATEGORIES_DATA = "LOAD_PHONE_CATEGORIES_DATA";
export const LOAD_PHONE_DATA = "LOAD_PHONE_DATA";
export const LOAD_PHONE_OFFER_COUNT = "LOAD_PHONE_OFFER_COUNT";
export const LOAD_PHONE_OFFERS_DATA = "LOAD_PHONE_OFFERS_DATA";
export const LOAD_PHONE_OPERATING_SYSTEM_DATA =
  "LOAD_PHONE_OPERATING_SYSTEM_DATA";
export const LOAD_PHONE_OPERATING_SYSTEM_PHONE_OFFER_IDS_DATA =
  "LOAD_PHONE_OPERATING_SYSTEM_PHONE_OFFER_IDS_DATA";
export const LOAD_PHONE_OPERATING_SYSTEM_PROPOSITION_IDS_DATA =
  "LOAD_PHONE_OPERATING_SYSTEM_PROPOSITION_IDS_DATA";
export const LOAD_PHONE_OPERATING_SYSTEMS_DATA =
  "LOAD_PHONE_OPERATING_SYSTEMS_DATA";
export const LOAD_PHONE_STATE_DATA = "LOAD_PHONE_STATE_DATA";
export const LOAD_PHONE_STATES_DATA = "LOAD_PHONE_STATES_DATA";
export const LOAD_PHONE_PHONE_OFFER_IDS_DATA =
  "LOAD_PHONE_PHONE_OFFER_IDS_DATA";
export const LOAD_PHONE_PHONE_OFFER_POPULAR_IDS_DATA =
  "LOAD_PHONE_PHONE_OFFER_POPULAR_IDS_DATA";
export const LOAD_PHONE_PROPOSITION_IDS_DATA =
  "LOAD_PHONE_PROPOSITION_IDS_DATA";
export const LOAD_PHONE_PROPOSITION_POPULAR_IDS_DATA =
  "LOAD_PHONE_PROPOSITION_POPULAR_IDS_DATA";
export const LOAD_PHONE_VARIANT_DATA = "LOAD_PHONE_VARIANT_DATA";
export const LOAD_PHONE_VARIANT_PHONE_OFFER_IDS_DATA =
  "LOAD_PHONE_VARIANT_PHONE_OFFER_IDS_DATA";
export const LOAD_PHONE_VARIANT_PROPOSITION_IDS_DATA =
  "LOAD_PHONE_VARIANT_PROPOSITION_IDS_DATA";
export const LOAD_PHONE_VARIANTS_DATA = "LOAD_PHONE_VARIANTS_DATA";
export const LOAD_PHONES_DATA = "LOAD_PHONES_DATA";
export const LOAD_PROPOSITION_COUNT = "LOAD_PROPOSITION_COUNT";
export const LOAD_PROPOSITIONS_DATA = "LOAD_PROPOSITIONS_DATA";
export const LOAD_PROVIDER_DATA = "LOAD_PROVIDER_DATA";
export const LOAD_PROVIDER_PROPOSITION_IDS_DATA =
  "LOAD_PROVIDER_PROPOSITION_IDS_DATA";
export const LOAD_PROVIDER_SIM_ONLY_IDS_DATA =
  "LOAD_PROVIDER_SIM_ONLY_IDS_DATA";
export const LOAD_PROVIDERS_DATA = "LOAD_PROVIDERS_DATA";
export const LOAD_SHOP_DATA = "LOAD_SHOP_DATA";
export const LOAD_SHOP_PHONE_OFFER_IDS_DATA = "LOAD_SHOP_PHONE_OFFER_IDS_DATA";
export const LOAD_SHOP_PROPOSITION_IDS_DATA = "LOAD_SHOP_PROPOSITION_IDS_DATA";
export const LOAD_SHOP_SIM_ONLY_IDS_DATA = "LOAD_SHOP_SIM_ONLY_IDS_DATA";
export const LOAD_SHOPS_DATA = "LOAD_SHOPS_DATA";
export const LOAD_SIM_ONLY_COUNT = "LOAD_SIM_ONLY_COUNT";
export const LOAD_SIM_ONLY_OFFERS_DATA = "LOAD_SIM_ONLY_OFFERS_DATA";
export const LOAD_SPONSORED_POSITIONS_DATA = "LOAD_SPONSORED_POSITIONS_DATA";
export const RESET_COLLABSIBLES = "RESET_COLLABSIBLES";
export const RESET_FILTER = "RESET_FILTER";
export const RESET_FILTERS = "RESET_FILTERS";
export const RESET_HAS_CHANGED_FILTERS = "RESET_HAS_CHANGED_FILTERS";
export const RESET_MODAL = "RESET_MODAL";
export const RESET_OFFER_RESULTS_PAGINATION = "RESET_OFFER_RESULTS_PAGINATION";
export const RESET_PHONE_PICKER = "RESET_PHONE_PICKER";
export const RESET_PHONE_SEARCH = "RESET_PHONE_SEARCH";
export const RESET_SORT = "RESET_SORT";
export const RESET_SORTS = "RESET_SORTS";
export const SWITCH_CLIENT_CONFIG = "SWITCH_CLIENT_CONFIG";
export const SWITCH_OFFER_TYPE = "SWITCH_OFFER_TYPE";
export const SWITCH_PORTAL = "SWITCH_PORTAL";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const UPDATE_MODAL = "UPDATE_MODAL";
export const UPDATE_COLLABSIBLE = "UPDATE_COLLABSIBLE";
export const UPDATE_EXPERIMENT = "UPDATE_EXPERIMENT";
export const UPDATE_HAS_CHANGED_FILTER = "UPDATE_HAS_CHANGED_FILTER";
export const UPDATE_PHONE_PICKER = "UPDATE_PHONE_PICKER";
export const UPDATE_PHONE_SEARCH = "UPDATE_PHONE_SEARCH";
export const UPDATE_OFFER_RESULTS_PAGINATION =
  "UPDATE_OFFER_RESULTS_PAGINATION";
export const UPDATE_SLIDER = "UPDATE_SLIDER";
export const UPDATE_SORT = "UPDATE_SORT";
